<div class="e911-add-location">
  <span class="e911-add-location__block mat-body-2">{{ "ONSIP_I18N.E911__DESC" | translate }}</span>
  <span
    class="e911-add-location__block mat-body-2"
    [innerHTML]="'ONSIP_I18N.E911__HELP_DESC' | translate : { link: LINK }"
  ></span>
</div>
